import * as React from "react"
import {useEffect, useState} from "react"
import {apiRequestGetMeetings} from "../../api/apiRequests"
import Loader from "../ui/Loader"

interface Meeting {
  id: number,
  specialistName: string,
  meetingDate: string,
  meetingTime: string,
}

const AppointmentsPage = () => {
  const [meetings, setMeetings] = useState<Meeting[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    apiRequestGetMeetings().then((data) => {
      if (Array.isArray(data)) setMeetings(data)
      setLoading(false)
    })
  }, [])

  if (loading) return <div className="appointments__loader"><Loader/></div>

  return (
    <section className="appointments">
      <div className="container">
        <div className="appointments__header">
          <h2 className="appointments__title">List of your appointments!</h2>
          <p className="appointments__subtitle">Your plan includes online sessions with a personal specialist. Once your appointment is scheduled, you will be contacted via email.</p>
        </div>
        <div className="appointments__grid">
          {meetings.length === 0 ? (
            <p className="appointments__empty">You have no appointments yet.</p>
          ) : (
            meetings.map((meeting) => (
              <div key={meeting.id} className="appointment-card">
                <p className="appointment-card__row">
                  <span className="appointment-card__label">Psychologist name:</span>{" "}
                  <span className="appointment-card__specialist">{meeting.specialistName}</span>
                </p>
                <p className="appointment-card__row">
                  <span className="appointment-card__label">Date of appointment:</span>{" "}
                  {meeting.meetingDate}, {meeting.meetingTime}
                </p>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  )
}

export default AppointmentsPage
